import { render, staticRenderFns } from "./findTalents.vue?vue&type=template&id=348ffdb0&scoped=true"
import script from "./findTalents.vue?vue&type=script&lang=js"
export * from "./findTalents.vue?vue&type=script&lang=js"
import style0 from "./findTalents.vue?vue&type=style&index=0&id=348ffdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348ffdb0",
  null
  
)

export default component.exports